import Tracker from "../../../../../prop-trackers/tracker.js";
import DictTracker from "../../../../../prop-trackers/dict-tracker.js";
import TrackerGroup from "../../../../../prop-trackers/tracker-group.js";
import ConsumingDictMux from "../../../../../prop-tracker-utils/consuming-dict-mux.js";
import Zipper from "../../../../../prop-tracker-utils/zipper.js";
import Mux from "../../../../../prop-tracker-utils/mux.js";

class ObjectTrackGenerator extends Tracker {
    constructor(objectNameTracker, objectAnimKeyTracker, trackIndexTracker, evtCtx) {
        super();

        this._evtCtx = evtCtx;

        const needsUpdate = () => this.protected_needsUpdate();

        const objectAnimDataTracker = new ConsumingDictMux(trackIndexTracker, objectAnimKeyTracker);

        this._zipper = new Zipper();
        this._zipper.listenNeedsUpdate(needsUpdate);

        this._zipper.setSource("name", objectNameTracker);
        this._zipper.setSource("animation", objectAnimDataTracker);

        this._muxes = {};
        this._muxKey = new WeakMap();
        this._muxGroup = new TrackerGroup();
        this._muxGroup.listenNeedsUpdate(needsUpdate);

        this._outputTracker = new DictTracker();
    }

    protected_startUpdate() {
        this._zipper.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ userdata: key, props }) => {
                    const name = props.get("name").newValue;
                    const animation = props.get("animation").newValue;

                    let mux = this._muxes[key];

                    if (typeof name === "string" && animation) {
                        if (!mux) {
                            mux = new Mux(key);
                            this._muxes[key] = mux;
                            this._muxKey.set(mux, key);
                            this._muxGroup.add(mux);
                        }

                        mux.setSource(animation, this._evtCtx.getEvents(animation));
                        mux.setKey(name);
                    } else {
                        if (mux) {
                            mux.setSource();
                            mux.setKey();
                            this._muxGroup.remove(mux);
                            delete this._muxes[key];
                        }
                    }
                });
            }
        });

        this._muxGroup.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ userdata: key, prop: { newExists, newValue } }) => {
                    if (newExists) {
                        this._outputTracker.setValue(key, newValue);
                    } else {
                        this._outputTracker.deleteValue(key);
                    }
                });
            }
        });

        return this._outputTracker.startUpdate();
    }

    protected_finishUpdate() {
        return this._outputTracker.finishUpdate();
    }
}

export default ObjectTrackGenerator;
